import { useContext, useEffect, useState } from "react";
import { ReactReduxContext } from "react-redux";

import { AppStrings } from "../../../utils/constants/AppStrings";

const primaryCurrencyNameFromState = (state: {
  config?: {
    appConfig?: {
      app_currency_config?: {
        primary_currency?: { name?: string; shortcode?: string };
      };
    };
  };
} | undefined): string => {
  const primary = state?.config?.appConfig?.app_currency_config?.primary_currency;
  return primary?.name?.trim() || primary?.shortcode?.trim() || "";
};

/**
 * Client primary-currency display name from platform config
 * (`app_currency_config.primary_currency.name`, e.g. "Rebet Cash").
 * Safe without a Redux Provider — falls back to AppStrings.PRIMARY_CURRENCY.
 * Subscribes so a late-arriving config remounts the Credit Wallet label.
 */
export const usePrimaryCurrencyName = (): string => {
  const reduxContext = useContext(ReactReduxContext);
  const [name, setName] = useState(
    () =>
      (reduxContext
        ? primaryCurrencyNameFromState(reduxContext.store.getState())
        : "") || AppStrings.PRIMARY_CURRENCY,
  );

  useEffect(() => {
    if (!reduxContext) return undefined;
    const sync = () => {
      setName(
        primaryCurrencyNameFromState(reduxContext.store.getState()) ||
          AppStrings.PRIMARY_CURRENCY,
      );
    };
    sync();
    return reduxContext.store.subscribe(sync);
  }, [reduxContext]);

  return name;
};
